import { User } from 'models/user';
import { UserSettingsRequest, UserSettingsResponse } from 'models/userSettings';

const getParams = (
	email: string,
	latestReadMessageDate: string,
	token: string
	// eslint-disable-next-line no-undef
): RequestInit => ({
	method: 'POST',
	headers: {
		'Content-Type': 'application/json',
		Authorization: `bearer ${token}`
	},
	body: JSON.stringify({
		email,
		latestReadMessageDate
	} as UserSettingsRequest)
});

const createSettingsFetcher = async (
	{ token, email }: User,
	latestReadMessageDate: string
): Promise<void> => {
	if (token) {
		fetch(
			`${process.env.REACT_APP_GATEWAY_URL}${window.config.Endpoints.SignalUserSettings}`,
			getParams(email, latestReadMessageDate, token)
		);
	}
};

const fetcher = async ({
	token,
	email
}: User): Promise<UserSettingsResponse> => {
	try {
		const response = await fetch(
			`${process.env.REACT_APP_GATEWAY_URL}${window.config.Endpoints.SignalUserSettingsEmail.replace('{email}', email)}`,
			{
				method: 'GET',
				headers: {
					Accept: 'application/json',
					Authorization: `bearer ${token}`
				}
			}
		);
		const result = await response.json();
		return await result[0];
	} catch (error) {
		console.log(error);
		const userObj: Partial<User> = {
			token,
			email,
			user: null as any,
			setUser: null as any,
			id: '',
			isPremium: false,
			emailEncrypted: '',
			name: '',
			phone: '',
			country: '',
			isEmployee: false
		};
		await createSettingsFetcher(userObj as User, new Date().toISOString());
		return {} as UserSettingsResponse;
	}
};

export async function getSignalsSettings(
	user: User
): Promise<UserSettingsResponse> {
	return fetcher(user);
}
